module.exports = __webpack_public_path__ + "img/chat-user6.9c9b955b.png";